<template>
  <el-dialog
    title="添加商会简介"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="product-add pb50">
      <el-form
        size="small"
        :model="form"
        ref="form"
        :rules="rules"
        label-width="100px"
      >
        <div class="common-form">添加商会简介</div>
        
        <el-form-item label="商会简介名称" prop="name">
          <el-input
            v-model="form.name"
            placeholder="请输入商会简介名称"
            class="max-w460"
          ></el-input>
        </el-form-item>

        <el-tabs v-model="selectMap" @tab-click="handleClick">
          <div>
            <el-form-item label="地址" prop="address">
              <el-input
                v-model="form.address"
                placeholder="请输入地址"
                class="max-w460"
              ></el-input>
            </el-form-item>
            <el-form-item label="坐标" prop="coordinate">
              <el-row class="mb16">
                <el-col :span="24">
                  <el-input
                    v-model="form.coordinate"
                    class="max-w460"
                  ></el-input>
                </el-col>
              </el-row>
              <el-row class="mb16">
                <el-col :span="24">
                  <Getpoint
                    v-if="selectMap == 1"
                    :form="form"
                    @getMapdata="getMapdataFunc"
                    @chose="choseFunc"
                  ></Getpoint>
                </el-col>
              </el-row>
            </el-form-item>
          </div>
        </el-tabs>

        <el-form-item label="电话" prop="phone">
          <el-input
            v-model="form.phone"
            placeholder="请输入电话"
            class="max-w460"
          ></el-input>
        </el-form-item>

        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model="form.email"
            placeholder="请输入邮箱"
            class="max-w460"
          ></el-input>
        </el-form-item>

        <el-form-item label="商会资质" prop="aptitude">
          <div v-for="(item, index) in form.aptitudes" :key="index" class="aptitude-item">
            <el-input
              v-model="form.aptitudes[index]"
              placeholder="请输入商会资质"
              class="max-w460"
            ></el-input>
            <el-button
              v-if="index > 0"
              @click="removeAptitude(index)"
              type="danger"
              icon="el-icon-minus"
              circle
              class="ml-10"
            ></el-button>
            <el-button
              @click="addAptitude"
              v-if="index === form.aptitudes.length - 1"
              type="primary"
              icon="el-icon-plus"
              circle
              class="ml-10"
            ></el-button>
          </div>
        </el-form-item>

        <el-form-item label="选择商会核心成员" prop="shop_core_member_id">
          <el-select
            v-model="form.shop_core_member_id"
            multiple
            filterable
            placeholder="请选择商会核心成员"
            style="width: 100%"
            :loading="loadingShopCoreMembers"
          >
            <el-option
              v-for="shopCoreMember in shopCoreMemberList"
              :key="shopCoreMember.shop_core_member_id"
              :label="shopCoreMember.name"
              :value="shopCoreMember.shop_core_member_id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="商会bannar" prop="model.image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.bannar">
              <transition-group>
                <div v-for="(item, index) in form.bannar" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path" />
                    <a
                      href="javascript:void(0);"
                      class="delete-btn"
                      @click.stop="deleteImg(index, 'bannar')"
                      ><i class="el-icon-close"></i
                    ></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('bannar')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="商会简介介绍">
          <div class="edit_container">
            <Uediter
              v-model="form.intro"
              :text="ueditor.text"
              :config="ueditor.config"
              ref="ue"
            ></Uediter>
          </div>
        </el-form-item>

        <el-form-item label="排序" prop="name">
          <el-input
            v-model="form.sort"
            placeholder="请输入排序"
            class="max-w460"
          ></el-input>
        </el-form-item>

        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button
            size="small"
            type="primary"
            @click="onSubmit"
            :loading="loading"
            >提交</el-button
          >
        </div>
      </el-form>
      
      <Upload
        v-if="isProductUpload"
        :config="{ total: 9 }"
        :isupload="isProductUpload"
        @returnImgs="returnProductImgsFunc"
        >上传图片
      </Upload>
    </div>
  </el-dialog>
</template>

<script>
import Shop_introApi from "@/api/shop_intro.js";
import Getpoint from "@/components/map/Getpoint.vue";
import Upload from "@/components/file/Upload";
import draggable from "vuedraggable";
import Uediter from "@/components/UE.vue";

export default {
  components: {
    Upload,
    draggable,
    Uediter,
    Getpoint
  },
  data() {
    return {
      loadingShopCoreMembers: false,
      shopCoreMemberList: [],
      selectMap: "1",
      isupload: false,
      isImg: false,
      ueditor: {
        text: "",
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      form: {
        shop_core_member_id: [],
        address: "",
        coordinate: "",
        aptitudes: [''], // 初始化为包含一个空字符串的数组
        name: "",
        code: "custom",
        image: [],
        sort: 50,
        intro: "",
        bannar: []
      },
      loading: false,
      rules: {
        name: [
          { required: true, message: "请输入商会简介名称", trigger: "blur" }
        ]
      },
      dialogVisible: false,
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.addShopCoreMemberList();
  },
  props: ["open_add"],
  methods: {
    addAptitude() {
      if (this.form.aptitudes[this.form.aptitudes.length - 1].trim() !== '') {
        this.form.aptitudes.push('');
      }
    },
    removeAptitude(index) {
      this.form.aptitudes.splice(index, 1);
    },
    addShopCoreMemberList() {
      Shop_introApi.shopCoreMemberListx({}, true)
        .then(data => {
          this.shopCoreMemberList = data.data;
        })
        .catch(error => {});
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    getMapdataFunc(e) {
      this.form.coordinate = e.data[0].toFixed(6) + "," + e.data[1].toFixed(6);
    },
    choseFunc(e) {
      this.form.coordinate = e.location.lat + "," + e.location.lng;
      this.form.address = e.address;
    },
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, type: "" });
    },
    cancelFunc() {
      this.dialogFormVisible("error");
    },
    onSubmit() {
      let self = this;
      let form = JSON.parse(JSON.stringify(this.form));
      
      // 转换aptitudes为aptitude并过滤空值
      form.aptitude = form.aptitudes.filter(item => item.trim() !== '');
      delete form.aptitudes; // 移除前端使用的字段
      
      form.intro = this.$refs.ue.getUEContent();
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Shop_introApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: "success"
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
    openProductUpload(code) {
      this.isProductUpload = true;
      this.code = code;
    },
    returnProductImgsFunc(e) {
      if (this.code == "album") {
        if (e != null) {
          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        }
      } else {
        if (e != null) {
          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }
      this.isProductUpload = false;
    },
    deleteImg(index, code) {
      if (code == "album") {
        this.form.image.splice(index, 1);
      } else if (code == "bannar") {
        this.form.bannar.splice(index, 1);
      }
    }
  }
};
</script>

<style>
/* 保持原有样式不变 */
</style>


// WEBPACK FOOTER //
// src/views/plus/shop_intro/index/part/add.vue